import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MxEventBusService {
  subject = new Subject<any>();

  constructor() {}

  on(event: MxEvents, action: any): Subscription {
    return this.subject
      .pipe(
        filter((e: MxEmitEvent) => {
          return e.name === event;
        }),
        map((e: MxEmitEvent) => {
          return e.value;
        })
      )
      .subscribe(action);
  }

  emit(event: MxEmitEvent) {
    this.subject.next(event);
  }
}

export class MxEmitEvent {
  constructor(public name: any, public value?: any) {}
}

export enum MxEvents {
  HttpRequest,
  HttpResponse,
  ColorSchemaChange
}
